/**
 * HeadingForm: edit form for the `heading` block.
 *
 * data: { text, level } where `level` is 2 or 3.
 *
 * A text input for the heading text and a 2/3 select for the level. The level
 * is stored as a Number so it matches the renderer's `level === 3` check.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col } from 'react-bootstrap';

export default function HeadingForm({ data, onChange }) {
    const d = data || {};

    return (
        <Row>
            <Col md={9}>
                <Form.Group className="mb-3" controlId="heading-text">
                    <Form.Label>Heading Text</Form.Label>
                    <Form.Control
                        type="text"
                        value={d.text || ''}
                        onChange={(e) =>
                            onChange({ ...d, text: e.target.value })
                        }
                        placeholder="Section heading"
                    />
                </Form.Group>
            </Col>
            <Col md={3}>
                <Form.Group className="mb-3" controlId="heading-level">
                    <Form.Label>Level</Form.Label>
                    <Form.Select
                        value={d.level === 3 ? 3 : 2}
                        onChange={(e) =>
                            onChange({
                                ...d,
                                level: Number(e.target.value),
                            })
                        }
                    >
                        <option value={2}>Heading 2</option>
                        <option value={3}>Heading 3</option>
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>
    );
}

HeadingForm.propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};

HeadingForm.defaultProps = {
    data: {},
};
